export default __webpack_public_path__ + "static/media/CBC-Grid.e1f21ba4.webp";